export const i18nLanguages = {
  1: 'pt-BR',
  2: 'en-US'
}
